import React, {useEffect, useState} from 'react'
import ReactPaginate from 'react-paginate';

import AuthHeader from '../components/Headers/AuthHeader.component';
import Footer1 from '../components/Footers/Footer1.component';
import JobCard from '../components/JobCard.component';
import SearchFilter from '../components/SearchFilter.component';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader.component';


export default function JobListings() {
  
    // Local State 
    const [posts, setPosts] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [flag, setFlag] = useState('');

    // Redux State
    const [filterMenu, setFilterMenu] = useState(false);
    const userData = useSelector(state => state.auth.data);
    const token = useSelector(state => state.auth.token);
    
    // console.log(userData);

    useEffect(() => {
        if(filterMenu){
            document.body.classList.remove("bds-open-filtermenu");
            document.body.classList.add("bds-open-filtermenu");
        }else {
            document.body.classList.remove("bds-open-filtermenu");
        }
        
        // get all posts 
        getAllPosts();
        
    }, [filterMenu, token]);

    
    const getAllPosts = async () => {

        let url = "";
        if(userData?.role == 2){
            url = `${process.env.REACT_APP_BASE_URL}/api/posts?latitude=${userData?.latitude}&longitude=${userData?.longitude}&near_by_radius=100`;
        } else if(userData?.role == 3){
            url = `${process.env.REACT_APP_BASE_URL}/api/posts?customer_id=${userData?.id}`
        }

        await fetch(url, {
        method: "GET",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
        .then(r => r.json())
        .then(response => {
            if(response.success){
                // let filteredData = response.records.data.filter(items => items.status !== 3 && items.distance <= 100 )
                
                if(userData?.role == 2){
                    let filteredData = response.records.data.filter(items => items.status === 1)
                    setPosts(filteredData);
                    setTotalRecords(filteredData.length);
                    setPageCount(Math.ceil(response.records.total / response.records.per_page));
                    filteredData.length === 0 && setFlag({type: "nofound", message: "No Job Found, Near you."})
                } else if(userData?.role === 3) {
                    let filteredData = response.records.data.filter(items => items.status !== 3)
                    setPosts(filteredData);
                    setTotalRecords(filteredData.length);
                    setPageCount(Math.ceil(response.records.total / response.records.per_page));
                    filteredData.length === 0 && setFlag({type: "nofound", message: "You can see your posted jobs here."})
                }

            }else {
                console.log(response);
            }
        })
    }

    const handlePageClick = async (event) => {
        const newOffset = (event.selected * totalRecords) % posts.length;        
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts?latitude=${userData?.latitude}&longitude=${userData?.longitude}&page=${event.selected + 1}&near_by_radius=100`, {
            method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    // let filteredData = response.records.data.filter(items => items.status !== 3 && items.distance <= 100 )
                    let filteredData = response.records.data.filter(items => items.status === 1 )
                    setPosts(filteredData);
                    setTotalRecords(response.records.total);
                    setPageCount(Math.ceil(response.records.total / response.records.per_page));
                }else {
                    console.log(response);
                }
            })        
    };

    return (
    <>
        <AuthHeader />

        {/* <!-- MAIN START --> */}
        <main className="bds-bg">
            <section className={`bds-main-section bds-searchresult`}>
                <div className="container">
                   {
                    <div className="row">
                        {/* <div className="col-lg-12">
                            <div className="bds-sort">
                                <div className="bds-sortby">
                                    <div className="bds-actionselect">
                                        <span>Sort by: </span>
                                        <div className="bds-select">
                                            <select className="form-control bds-selectprice">
                                                <option>Price low to high </option>
                                                <option>Price high to low</option>
                                            </select>
                                        </div>
                                        <button type='button' onClick={() => setFilterMenu(true)} className="bds-filtermenu"><i className="icon-sliders"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-4 col-xl-3">
                            <SearchFilter 
                                toggleFilter={filterMenu} 
                                setToggleFilter={setFilterMenu} 
                                setFlag={setFlag}
                                setPosts={setPosts}
                            />
                        </div>
                        <div className="col-lg-8 col-xl-9">
                            {
                                !flag && posts ? 
                                <>
                                    <div className="row">
                                        
                                        {
                                            posts?.map(post => 
                                               <div className="col-md-6 col-xl-4" key={post.id}>
                                                    <JobCard                                                 
                                                        post={post}
                                                    />
                                                </div>                                        
                                            )
                                        }
        
                                    </div>
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="Next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< Previous"
                                        renderOnZeroPageCount={null}
                                        containerClassName={"pagination justify-content-center"}
                                        subContainerClassName={"page-item"}
                                        pageClassName="page-item"
                                        activeClassName={"active"}
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        nextClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextLinkClassName="page-link"
                                        disabledClassName="disabled"
                                    />                                
                                </>
                                : ((<p className='text-center text-muted'>{flag.message}</p>))
                            }
                        </div>

                    </div>
                   }
                </div>
            </section>
        </main>
        {/* <!-- MAIN END --> */}

        <Footer1 />

    </>
  )
}
